import { NotepadIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'
import { Navigate, useLocation } from 'react-router-dom'

import { Question } from '@/api/reservations/get-reservation-details'
import { Typography } from '@/components/ui/typography'
import { EMPTY_VALUE } from '@/constants'

import * as S from '../reservations-details.styled'

interface Props {
  questions?: Question[]
  isLoading?: boolean
}

export const CustomQuestions = ({ questions, isLoading }: Props) => {
  const { t } = useTranslation(['reservations'])
  const location = useLocation()

  if (!isLoading && !questions?.length) {
    return <Navigate replace to={location.pathname} />
  }

  return (
    <S.CompactCard>
      <S.BasicInfo>
        <NotepadIcon />
        <Typography size="heading-small" weight="bold">
          {t('reservations:details.customQuestions.customQuestions')}
        </Typography>
      </S.BasicInfo>

      <S.Table>
        {questions?.map((question) => (
          <S.Row key={question.id}>
            <S.Label $width="50%">{question.question}</S.Label>
            <S.Value>{question.answer || EMPTY_VALUE}</S.Value>
          </S.Row>
        ))}
      </S.Table>
    </S.CompactCard>
  )
}
